import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { VisitLookup } from "../../../reporting/data-completeness/components/visits-tab/scripts/visits.lookup";
import { Study } from "../../../../shared/entities/scripts/study";
export class BiospecimenInventoryLookup {
    static SAMPLE_TYPES: string[] = [
        "Plasma - Na Hep",
        "Serum - SST",
        "Stool - OMR-205",
        "Stool - ME-200",
        "Whole Blood - EDTA",
        "PAXgene RNA",
        "PBMC - CPT Na Citrate",
        "Plasma - CPT Na Hep",
        "PBMC - Na Hep",
        "Plasma - EDTA"
    ];
    static GetAlphabeticalSampleTypes(): string[] {
        return [...this.SAMPLE_TYPES].sort((a, b) => a.localeCompare(b));
    }

    static SampleTypeIdToIndex(id: number): number {
        switch (id) {
            case 1: return this.SAMPLE_TYPES.indexOf("Plasma - Na Hep");
            case 2: return this.SAMPLE_TYPES.indexOf("Serum - SST");
            case 3: return this.SAMPLE_TYPES.indexOf("Stool - OMR-205");
            case 4: return this.SAMPLE_TYPES.indexOf("Stool - ME-200");
            case 5: return this.SAMPLE_TYPES.indexOf("Whole Blood - EDTA");
            case 6: return this.SAMPLE_TYPES.indexOf("PAXgene RNA");
            case 7: return this.SAMPLE_TYPES.indexOf("PBMC - CPT Na Citrate");
            case 8: return this.SAMPLE_TYPES.indexOf("Plasma - CPT Na Hep");
            case 9: return this.SAMPLE_TYPES.indexOf("PBMC - Na Hep");
            case 10: return this.SAMPLE_TYPES.indexOf("Plasma - EDTA");
            default: return -1;
        }
    }

    static GetValueFromIdAndType(id: number, type: string): string {
        if (type == 'trial') {
            return Appendix.GetAppendixName(id);
        }
        else if (type == 'study') {
            return Study.GetStudyName(id);
        }
        else if (type == 'sample-type') {
            switch (id) {
                case 1: return "Plasma - Na Hep";
                case 2: return "Serum - SST";
                case 3: return "Stool - OMR-205";
                case 4: return "Stool - ME-200";
                case 5: return "Whole Blood - EDTA";
                case 6: return "PAXgene RNA";
                case 7: return "PBMC - CPT Na Citrate";
                case 8: return "Plasma - CPT Na Hep";
                case 9: return "PBMC - Na Hep";
                case 10: return "Plasma - EDTA";
                default: return "Missing Value";
            }
        }
        else if (type == 'recover-cohort') {
            switch (id) {
                case (0): return "Unknown"
                case (1): return "No";
                case (2): return "Yes";
                //case (9): return "Unknown";
            }
        }
        else if (type == 'specimen-status') {
            switch (id) {
                case (1): return "Allocated";
                case (2): return "Available";
                default: return "Unknown Status";
            }
        }
        else if (type == 'sex') {
            switch (id) {
                case (0): return "Female";
                case (1): return "Male";
                case (2): return "Intersex";
                case (3): return "Prefer Not To Answer";
                default: return "Unknown";
            }
        }
        else if (type == 'race') {
            switch (id) {
                case (0): return "Multi-Racial";
                case (1): return "American Indian or Alaska Native";
                case (2): return "Asian";
                case (3): return "Black";
                case (4): return "Middle East or North Africa";
                case (5): return "Native Hawaiian or Pacific Islanders";
                case (6): return "White";
                case (7): return "Unknown";
                default: return "Missing Value";
            }
        }
        else if (type == 'ethnicity') {
            switch (id) {
                case (1): return "Not Hispanic";
                case (2): return "Hispanic";
                case (3): return "Unknown";
                default: return "No information";
            }
        }
        else if (type == 'age') {
            switch (id) {
                case (0): return "18 - 45";
                case (1): return "46 - 65";
                case (2): return ">65";
                case (3): return "Unknown";
                default: return "No Information";
            }
        }
        else if (type == "timepoint") {
            switch (id) {
                case 0: return "";
                case 1: return "Days 0";
                case 2: return "Days 1 to 50";
                case 3: return "Days 51 to 75";
                case 4: return "Days 76 to 90";
                case 5: return "Days 91 to 168";
                case 6: return "Days 169 to 336";
                case 7: return "Unscheduled Visit";
                default: return "Unknown";
            }
        }
        else if (type == "unit") {
            switch (id) {
                case 0: return "";
                case 1: return "ALIQUOT";
                case 2: return "TUBE";
                default: return "Unknown";
            }
        }
        else if (type == "study") {
            switch (id) {
                case (2): return "VITAL";
                case (3): return "NEURO";
                case (4): return "SLEEP";
                case (5): return "AUTONOMIC";
                case (6): return "ENERGIZE";
            }
        }
        else if (type == "treatment") {
            switch (id) {
                case (1): return "AUTONOMIC - Screened - Never Enrolled";
                case (2): return "ENERGIZE - Screened - Never Enrolled";
                case (3): return "NEURO - Active Comparator";
                case (4): return "NEURO - BrainHQ";
                case (5): return "NEURO - BrainHQ + PASC CoRe";
                case (6): return "NEURO - BrainHQ + tDCS-active";
                case (7): return "NEURO - BrainHQ + tDCS-sham";
                case (8): return "Pending";
                case (9): return "SLEEP - Screened - Never Enrolled";
                case (10): return "VITAL - Control (25 Days)";
                case (11): return "VITAL - Paxlovid (15 Days)/Control (10 Days)";
                case (12): return "VITAL - Paxlovid (25 Days)";
                case (13): return "VITAL - Screened - Never Enrolled";
                default: return "Unknown";
            }
        }
        //else if (type == "study") {
        //    switch (id) {
        //        case (2): return "VITAL";
        //        case (3): return "NEURO";
        //        case (4): return "SLEEP";
        //        case (5): return "AUTONOMIC";
        //        case (6): return "ENERGIZE";
        //    }
        //}

        else if (type == "collection-window") {
            return VisitLookup.GetVisitMasterColumn(id);
        }
        else if (type == "symptom-cluster") {
            switch (id) {
                case (1): return "VITAL - Autonomic Dysfunction, Cognitive Dysfunction";
                case (2): return "VITAL - Cognitive Dysfunction";
                case (3): return "VITAL - Exercise Intolerance";
                case (4): return "VITAL - Exercise Intolerance, Autonomic Dysfunction";
                case (5): return "VITAL - Exercise Intolerance, Autonomic Dysfunction, Cognitive Dysfunction";
                case (6): return "VITAL - Exercise Intolerance, Cognitive Dysfunction";
                case (7): return "VITAL - Autonomic Dysfunction";
                case (8): return "VITAL - None";
                case (9): return "Not Applicable";
            }
        }
        else if (type == "unit-measure") {
            switch (id) {
                case 1: return "microlitres";
                case 2: return "cells";
                case 3: return "units";
                case 4: return "mass of DNA";
                case 5: return "mass of RNA";
                default: return "units";
            }
        }
    }
}